import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

//constants
import { ENDPOINTS } from "constants/endpoints"

//hooks
import useFetch from "hooks/useFetch"

let searchDeactevatedUsersTimeout
function useFetchDeactivateUsers(search = "") {
    const { fetch, loading } = useFetch()

    const [users, setUsers] = useState([])
    const navigate = useNavigate()

    useEffect(() => {
        clearTimeout(searchDeactevatedUsersTimeout)
        searchDeactevatedUsersTimeout = setTimeout(() => {
            _fetchData()
        }, getFetchTimeout())
    }, [search])

    function getFetchTimeout() {
        if (users.length) {
            return 300
        }

        return 0
    }

    function _fetchData() {
        navigate({
            search: search.length ? `?name=${search}` : null,
        })

        fetch({ endpoint: `user/get-deactivated?name=${search}`, method: 'get' })
            .then(res => {
                setUsers(res.data.users)
            })
    }

    function getDeactivatedUsers() {
        return users
    }

    function refetchData() {
        _fetchData()
    }

    return {
        getDeactivatedUsers,
        loadingDeactivatedUsers: loading,
        refetchDeactivatedUsersData: refetchData
    }
}

export default useFetchDeactivateUsers